module.exports = __webpack_public_path__ + "img/personal-active.4a2f5881.svg";